document.querySelectorAll('.wishlist-engine, .wishlist-engine *').forEach(function(button) {
    button.addEventListener('click', function(e) {
        e.stopPropagation();
    });
});

document.querySelectorAll('.gift_category_panel_products_swiper').forEach((el, index) => {
    new Swiper(el, {
        slidesPerView: 3,
        spaceBetween: 10,
        loop: false,
        navigation: {
        nextEl: el.parentElement.querySelector('.swiper-button-next'),
        prevEl: el.parentElement.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
        750: {
            slidesPerView: 4,
            spaceBetween: 15,
        },
        900: {
            slidesPerView: 5,
            spaceBetween: 20,
        },
        },
    });
});